import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private storage:StorageService){}
  // Created behaviour subject display which holds 2 values open|close 
  profileComponentDisplay: BehaviorSubject<'open' | 'close'>  = new BehaviorSubject<'open' | 'close'>('close');
  EditprofileComponentDisplay: BehaviorSubject<'open' | 'close'>  = new BehaviorSubject<'open' | 'close'>('close');
  CanvasComponentDisplay: BehaviorSubject<'open' | 'close'>  = new BehaviorSubject<'open' | 'close'>('close');
  QRComponentDisplay: BehaviorSubject<'open' | 'close'>  = new BehaviorSubject<'open' | 'close'>('close');
  controllerUuid: any;
  controllerSerialNumber: any;
  controllerModelNumber: any;

  // Profile Settings Page

  watchProfileComponentDisplay(): Observable<'open' | 'close'> {

    return this.profileComponentDisplay.asObservable();
  }

  closeProfileDisplay() {
    this.profileComponentDisplay.next('close');
  }

  openProfileDisplay() {
    this.profileComponentDisplay.next('open');
  }

  watchEditProfileComponentDisplay(): Observable<'open' | 'close'> {
    return this.EditprofileComponentDisplay.asObservable();
  }

  closeEditProfileDisplay() {
    this.EditprofileComponentDisplay.next('close');
  }

  openEditProfileDisplay() {
    this.EditprofileComponentDisplay.next('open');
  }

  watchCanvasComponentDisplay(): Observable<'open' | 'close'> {
    return this.CanvasComponentDisplay.asObservable();
  }

  closeCanvasDisplay() {
    this.CanvasComponentDisplay.next('close');
  }

  openCanvasDisplay(controller_uuid: any,controller_serial_number: any,controller_model_number: any) {
    this.storage.saveToLocalStorage("qr_uuid",controller_uuid)
    this.storage.saveToLocalStorage("qr_serial_number",controller_serial_number)
    this.storage.saveToLocalStorage("model_number",controller_model_number)
    this.CanvasComponentDisplay.next('open');
  }

  watchQrComponentDisplay(): Observable<'open' | 'close'> {
    return this.QRComponentDisplay.asObservable();
  }

  closeQrsDisplay() {
    this.QRComponentDisplay.next('close');
  }

  openQrDisplay() {
    this.QRComponentDisplay.next('open');
  }

}
